import PropTypes from "prop-types";
import GridContext from "./GridContext";

const Grid = ({ columns = 12, gutter = 12, children, ...rest }) => {
  return (
    <GridContext.Provider value={{ columns, gutter }}>
      <div {...rest}>{children}</div>
    </GridContext.Provider>
  );
};

Grid.propTypes = {
  columns: PropTypes.number,
  gutter: PropTypes.number,
  children: PropTypes.node,
};

export default Grid;
